import { render } from "./SearchItems.vue?vue&type=template&id=72fd73c8"
import script from "./SearchItems.vue?vue&type=script&lang=js"
export * from "./SearchItems.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\phili\\work\\dingsda\\dingsda_2mex_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__